export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7225.b14d3945.jpg";